import { call, put, takeLatest } from "redux-saga/effects";
import api from "service/apiService";
import {
	CreateNotificationPayload,
	DeleteNotificationPayload,
	GetDetailNotificationPayload,
	GetListNotificationPayload,
	UpdateNotificationPayload,
	createNotificationAsync,
	deleteNotificationAsync,
	getDetailNotificationAsync,
	getListNotificationAsync,
	setDetailNotification,
	setListNotification,
	updateNotificationAsync,
} from "./notification.slice";
import { message } from "antd";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";

function* getListNotificationSaga(
	action: PayloadAction<GetListNotificationPayload>,
) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get("/dashboard/notifications-system", {
				...query,
				skip: query.skip * query.take,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setListNotification.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetListNotification() {
	yield takeLatest(getListNotificationAsync, getListNotificationSaga);
}

function* createNotificationSaga(
	action: PayloadAction<CreateNotificationPayload>,
) {
	const { data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.post("/dashboard/notifications-system", data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(translate("Create successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchCreateNotification() {
	yield takeLatest(createNotificationAsync, createNotificationSaga);
}

function* updateNotificationSaga(
	action: PayloadAction<UpdateNotificationPayload>,
) {
	const { id, data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.put(
				`/dashboard/notifications-system/${id}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.();
		message.success(translate("Update successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateNotification() {
	yield takeLatest(updateNotificationAsync, updateNotificationSaga);
}

function* getDetailNotificationSaga(
	action: PayloadAction<GetDetailNotificationPayload>,
) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get(`/dashboard/notifications-system/${id}`);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.();
		yield put({ type: setDetailNotification.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetDetailNotification() {
	yield takeLatest(getDetailNotificationAsync, getDetailNotificationSaga);
}

function* deleteNotificationSaga(
	action: PayloadAction<DeleteNotificationPayload>,
) {
	const { id, query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.delete(
				`/dashboard/notifications-system/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: getListNotificationAsync.type, payload: { query, callback } });
		message.success(translate("Delete successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchDeleteNotification() {
	yield takeLatest(deleteNotificationAsync, deleteNotificationSaga);
}

const notificationSaga = [
	watchGetListNotification(),
	watchCreateNotification(),
	watchUpdateNotification(),
	watchGetDetailNotification(),
	watchDeleteNotification(),
];

export default notificationSaga;
